// exports.tableRowClassName=function(row, rowIndex) {
//   if (rowIndex === 0) {
//     return 'warning-row';
//   } else if (rowIndex === 1) {
//     return 'success-row';
//   }
//   return '';
// }

function changeTRcolor(row, rowIndex) {
  if (rowIndex % 2 == 0) {
    return 'warning-row';
  } else {
    return 'success-row';
  }
  return '';
}

function uploadImg($http,imgArray,param,baseUrl){

  let img = new FormData()
  img.append('img', param.file)
  let conf = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  $http.post(baseUrl+'/yszbsc/goodsinfo/Putimg', img, conf)//现网
 // $http.post(baseUrl+'/yszbsc/goodsinfo/Putimgssssssss', img, conf)//本地
    .then(res => {
      imgArray.push(res.data.img_url);
      return imgArray;
    }).catch(() => alert('图片上传服务器异常'));
}
function getSBXH(){
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

  if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
    // this.SBXH='PC';
    return 'PC';
  }else{
    // this.SBXH='PHONE';
    return 'PHONE';
  }
}

export {
  changeTRcolor,
  uploadImg,
  getSBXH
}



// WEBPACK FOOTER //
// ./src/api/common.js